import Vue from 'vue'

export default {
  selectLocation (id, data) {
    return Vue.http.patch('/location/selection/' + id, data)
  }
}
